export default {
    basePath: "https://api.cimos.cn/",
    viewImage: 'https://file.cimos.cn/',
    uploadFile: 'https://api.cimos.cn/',                  //上传文件
};